// extracted by mini-css-extract-plugin
export default {"err":"typedText_err__7YsDL","wordErr":"typedText_wordErr__hRvQj"};